'use client';

import { useInfiniteQuery, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { getInfinityArticles, getRubricsQuery } from '@/features/articles';
import { Topic } from '.';

interface TopicByRubricProps {
  rubric: string;
}

export const TopicByRubric = ({ rubric }: TopicByRubricProps) => {
  const {
    isFetching,
    data: infinityArticles,
    fetchNextPage,
    hasNextPage,
  } = useInfiniteQuery(
    getInfinityArticles({
      rubric,
      key: 'articles',
      limit: 15,
    })
  );

  const { data: rubrics } = useQuery(getRubricsQuery());

  const rubricName = rubrics?.find((item) => item.slug === rubric)?.name ?? '';

  const articles = useMemo(() => {
    return infinityArticles?.pages.flatMap((page) => page.articles) ?? [];
  }, [infinityArticles]);

  return (
    <Topic
      title={rubricName}
      articles={articles}
      onFetchMore={fetchNextPage}
      isFetching={isFetching}
      hasNextPage={hasNextPage}
    />
  );
};
